var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":`${_vm.$t('IMPORTS.CHOOSE_MODEL')}`},on:{"change":_vm.modelChanged},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.models),function(model,index){return _c('el-option',{key:index,attrs:{"value":model.key,"label":model.model}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }